import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { api } from "../api";

export function useSparklineData(
  selectedMonthDate: string,
  enabled: boolean
) {
  const month = moment(selectedMonthDate).month() + 1;
  const year = moment(selectedMonthDate).year();

  return useQuery({
    queryKey: ["sparklineData", year, month],
    queryFn: () => api.pricingNotifications.sparklines(month, year),
    enabled,
    staleTime: 10 * 60 * 1000,
  });
}
